function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.8972 0 0 50.8972 499.9998 499.9999)",
    id: 128470
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(235,87,87)",
      strokeWidth: 1.3396,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,87,87)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-15.5973, -15.9635)",
    d: "M 11.132 8 C 8.66589 8 6.66669 9.9792 6.66669 12.4207 C 6.66669 14.3917 7.44782 19.0693 15.1396 23.7986 C 15.4182 23.9699 15.7765 23.9699 16.055 23.7986 C 23.7468 19.0693 24.528 14.3917 24.528 12.4207 C 24.528 9.9792 22.5288 8 20.0627 8 C 17.5966 8 15.5973 10.6792 15.5973 10.6792 C 15.5973 10.6792 13.5981 8 11.132 8 Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heartFilled.13e6b2e5f49fc4371d86652540b82afe.svg";
export { ForwardRef as ReactComponent };